import AGREGAR_CATALOGO_TIPO_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/tiposdocumentos/agregarCatalogoTipoDocumento.gql';
import ACTUALIZAR_CATALOGO_TIPO_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/tiposdocumentos/actualizarCatalogoTipoDocumento.gql';
import REMOVER_CATALOGO_TIPO_DOCUMENTO from '@/graphql/mutations/administracion/catalogos/tiposdocumentos/removerCatalogoTipoDocumento.gql';
import CATALOGO_TIPOS_DOCUMENTOS from '@/graphql/querys/administracion/catalogos/tiposdocumentos/catalogoTiposDocumentos.gql';

export default {
  methods: {
    // AGREGAR TIPO DE DOCUMENTO
    async mixAgregarCatalogoTipoDocumento() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CATALOGO_TIPO_DOCUMENTO,
          variables: {
            tipoDocumento: this.tipoDocumento,
          },
          update: (store, { data: { agregarCatalogoTipoDocumento } }) => {
            const query = {
              query: CATALOGO_TIPOS_DOCUMENTOS,
            };
            const { catalogoTiposDocumentos } = store.readQuery(query);
            const catalogoTiposDocumentosCopia = catalogoTiposDocumentos.slice();
            catalogoTiposDocumentosCopia.push(agregarCatalogoTipoDocumento);
            store.writeQuery({
              ...query,
              data: {
                catalogoTiposDocumentos: catalogoTiposDocumentosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    // ACTUALIZAR TIPO DE DOCUMENTO
    async mixActualizarCatalogoTipoDocumento() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CATALOGO_TIPO_DOCUMENTO,
          variables: {
            id: this.tipoDocumentoEditar.id,
            tipoDocumento: this.tipoDocumento,
          },
          update: (store, { data: { actualizarCatalogoTipoDocumento } }) => {
            const query = {
              query: CATALOGO_TIPOS_DOCUMENTOS,
            };
            const { catalogoTiposDocumentos } = store.readQuery(query);
            const index = catalogoTiposDocumentos
              .findIndex(({ id }) => id === this.tipoDocumentoEditar.id);
            if (index !== -1) {
              catalogoTiposDocumentos.splice(index, 1, actualizarCatalogoTipoDocumento);
            }
            store.writeQuery({
              ...query,
              data: {
                catalogoTiposDocumentos,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    // ELIMINAR TIPO DE DOCUMENTO
    async mixEliminarCatalogoTipoDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_TIPO_DOCUMENTO,
        variables: {
          id: this.tipoDocumentoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CATALOGO_TIPOS_DOCUMENTOS,
          };
          const data = store.readQuery(query);
          const { catalogoTiposDocumentos } = data;
          const index = catalogoTiposDocumentos
            .findIndex(({ id }) => id === this.tipoDocumentoEliminar.id);
          if (index !== -1) {
            catalogoTiposDocumentos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
